<template>
  <div class="d-flex flex-column flex-md-row h-100 justify-content-between pb-2">
    <div class="d-flex flex-column justify-content-between">
      <div
        class="text-green text-center mr-md-4"
      >
        {{ notExecutedReason }}
      </div>
      <div v-show="!hasReasonAndItsDuval">
        {{ $t('fields.engineering.chromatography.multiplier') }}: {{ $n(data.multiplier) }}
      </div>
    </div>
    <s-table
      v-show="!hasReasonAndItsDuval"
      class="not-executed__table"
      table-class="fixed-header mb-0"
      small
      :fields="fields"
      :items="data.gas"
    >
      <template
        #cell(aal)="{ item }"
      >
        {{ $n(item.aal) }}
      </template>
    </s-table>
  </div>
</template>

<script>
import { Rules } from 'sigma-mappings';

export default {
  props: {
    data: null,
    rule: String,
  },
  computed: {
    hasReason() {
      return this.data.reason && this.data.reason.code;
    },
    hasReasonAndItsDuval() {
      return this.hasReason && this.rule === Rules.DUVAL;
    },
    notExecutedReason() {
      if (this.hasReasonAndItsDuval) {
        const { messageCode, algorithm } = this.getDuvalMessageCodeAndParam();
        return this.$t(`messages.${messageCode}.message`, { 0: algorithm });
      }
      return this.notExecutedDefaultMessage;
    },
    notExecutedDefaultMessage() {
      return this.$t('engineering.chromatography.methods-and-diagnostics.individual-analysis.not-executed.message');
    },
    fields() {
      return [
        {
          key: 'gas',
          label: this.$t('fields.engineering.chromatography.gas-information.gas'),
        },
        {
          key: 'aal',
          label: this
            .$t('fields.engineering.chromatography.limit-for-analytical-accuracy-abbreviation'),
        },
      ];
    },
  },
  methods: {
    getDuvalMessageCodeAndParam() {
      const reason = this.data.reason || {};
      const messageCode = reason.code;
      const messageParameters = reason.parameters || [];
      const algorithm = this.$t(`engineering.chromatography.method-parameters.${messageParameters[0]}`);
      return { messageCode, algorithm };
    },
  },
};
</script>

<style lang="sass" scoped>
.not-executed
  &__table
    min-width: 140px
    max-width: 140px
    display: flex
    align-items: center
    ::v-deep table
      max-height: 9rem
</style>
